import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function FullPageLoader() {
  return (
    <div className="flex h-screen items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-border border-t-primary" />
    </div>
  );
}

export function AdminGuard() {
  const { session, user } = useAuth();
  const location = useLocation();

  if (session === undefined) return <FullPageLoader />;
  if (session === null) return <Navigate to="/login" replace state={{ from: location }} />;
  if (!user?.isAdmin) return <Navigate to="/unauthorized" replace />;

  return <Outlet />;
}
